import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import {
  Router,
  NavigationEnd,
  Event,
  NavigationStart,
  NavigationError,
  RoutesRecognized,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Product } from "src/app/shared/classes/product";
import { CommonService } from "src/app/shared/services/common.service";
import { CouponesService } from "src/app/shared/services/coupones.service";
import { ProductService } from "src/app/shared/services/product.service";
import { UserService } from "src/app/shared/services/user.service";
import { environment } from "src/environments/environment";

import Swal from "sweetalert2";

import * as moment from "moment";

@Component({
  selector: "app-browse-log",
  templateUrl: "./browse-log.component.html",
  styleUrls: ["./browse-log.component.scss"],
})
export class BrowseLogComponent implements OnInit {
  urlimage;
  public products: Product[] = [];

  userLogedIn: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  usre_id: any;
  user_name = "";
  email = "";
  brief = "";
  mobile = "";
  address = "";
  password = "";
  public errorOccurred = false;
  public errorOccurredMessage = "";
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "سجل التصفح" : "Browsing Log";
  successMobile: boolean = false;
  successUser_name: boolean = false;
  successEmail: boolean = false;
  public openDashboard: boolean = false;
  public errorSuccessEmailMessage = "";

  public errorUserNameMessage = "";

  errorMobileMessage = "";
  successPassword: boolean = false;
  errorPasswordMessage = "";

  usedCouponesActive: boolean = false;

  activeCouponesList: any[] = [];
  usedCouponesList: any[] = [];
  finished: boolean = false;
  loading: boolean = false;
  public addItemCount = 0;
  currentUrl: string = "";
  hostName: string = "";
  // public start = 0;

  // BROWSE HISTORY
  // allBrowse: any[] = [];
  constructor(
    private toastrService: ToastrService,
    private user: UserService,
    public commonService: CommonService,
    private router: Router,
    public productService: ProductService
  ) {
    // SET TITLE
    this.commonService.setTitle(this.page_name);

    this.urlimage = this.commonService._ImageUrl + "products/thumbs/";
  }

  ngOnInit(): void {
    this.allBrowseProductHistory();
    this.checkOuth();
    this.hostName = this.commonService.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/browse-log`;
  }
  handleImageError(e) {
    e.src = "assets/images/product/placeholder2.jpg";
  }
  removeBrackets(str: string): string {
    return str?.replace(/[\()%/]/g, "");
  }
  createTimeSince(date) {
    return moment(date).locale(this.commonService._lang_code).fromNow();
  }

  onScroll() {
    this.loading = true;
    this.addItemCount += 10;
    this.allBrowseProductHistory();
  }

  allBrowseProductHistory() {
    // this.finished = false;
    this.productService
      .allBrowseProductHistory(this.addItemCount)
      .subscribe((data) => {
        this.finished = true;
        this.loading = false;
        if (data.success) {
          // this.products = data.data
          this.products.push(...data.data);
          // console.log("browse history ", this.products);
        }
      });
  }

  clearAllBrowseHistory() {
    Swal.fire({
      text:
        this.commonService._lang_code == "ar"
          ? "هل انت متأكد من حذف جميع سجلات التصفح؟"
          : "Are you sure you want to delete ALL browse history?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: getComputedStyle(
        document.querySelector("app-root")
      ).getPropertyValue("--theme-default"),
      cancelButtonColor: getComputedStyle(
        document.querySelector("app-root")
      ).getPropertyValue("--theme-default2"),
      confirmButtonText: this.commonService._lang_code == "ar" ? "نعم" : "Yes",
      cancelButtonText: this.commonService._lang_code == "ar" ? "لا" : "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.productService
          .deleteAllBrowseProductHistory()
          .subscribe((data) => {
            if (data.success) {
              this.toastrService.error(data.message);
              this.products = [];
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });

    // this.productService.deleteAllBrowseProductHistory().subscribe((data) => {
    //   if (data.success) {
    //     this.toastrService.error(data.message);
    //   }
    // })
  }

  async addToCart(product: any) {
    const status = await this.productService.addToCart(product);
    if (status) {
      this.router.navigate(["/shop/cart"]);
      // this.removeItem(product);
    }
  }

  removeItem(productId: any, index: any) {
    this.productService
      .deleteBrowseProductHistory(productId)
      .subscribe((data) => {
        if (data.success) {
          this.toastrService.error(data.message);

          // this.productService
          //   .allBrowseProductHistory(0, 999)
          //   .subscribe((data) => {
          //     if (data.success) {
          //       console.log("browse history after delete ", data);
          //     }
          //   });

          // console.log('browse after delete ', this.allBrowseProductHistory());

          this.products.splice(index, 1);
        }
      });
  }
  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }
  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_name = this.currentUser.user_name;
      this.email = this.currentUser.email;
      this.brief = this.currentUser.brief;
      this.address = this.currentUser.address;
      this.mobile = this.currentUser.mobile;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }
  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = [];
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    this.commonService.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
